import { useQuery } from "@tanstack/react-query";
import referralCodeService from "..";

const useValidateReferralCode = (referralCode: string) =>
  useQuery({
    queryKey: ["get-referral-code", referralCode],
    queryFn: () => referralCodeService.validateReferralCode(referralCode),
    select: (res) => res,
    enabled: !!referralCode,
  });

export { useValidateReferralCode };
